import React, { Component } from 'react';
import { get, post } from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import { inject, observer } from 'mobx-react';


@inject('userStore')
@observer
class InvoiceView extends Component {

  render(){
    const {invoice, modalBackgroundClicked} = this.props;
    return (
      <React.Fragment>
        <div className="modal-header">
            <h4 className="modal-title">#{invoice.invoice_number}: {invoice.description}</h4>
        </div>
        <div className="modal-body">
          <div className="card">
            <div className="card-body">
              <div className="card">
                  <h3 className="card-title">Services</h3>
                  <table className="table table-striped">
                      <tbody>
              {invoice.service_list.length === 0 ?
              <tr><td>No Services</td></tr>
              : invoice.service_list.map((service, index)=>
              <tr key={index}>
                  <td style={{width: 70+'%'}}>{service.name}</td>
                  <td style={{width: 10+'%', textAlign:'center'}}>{service.quantity}</td>
                  <td style={{width: 20+'%', textAlign:'right'}}>${service.price}</td>
              </tr>
              )}
                      </tbody>
                  </table>
                  <div className="card-footer">
                    <h4 className="text-right">Service Total: ${invoice.service_total}</h4>
                  </div>
              </div>
              <div className="card">
                  <h3 className="card-title">Line Items</h3>
                  <table className="table table-striped">
                      <tbody>
              {invoice.lineitem_list.map((lineitem, index)=>
              <tr key={index}>
                  <td style={{width: 70+'%'}}>{lineitem.name}</td>
                  {lineitem.is_percentage ?
                    <React.Fragment>
                      <td style={{width: 10+'%', textAlign:'center'}}>{lineitem.price}%</td>
                      <td style={{width: 20+'%', textAlign:'right'}}>${lineitem.total}</td>
                    </React.Fragment>
                  :
                  <React.Fragment>
                    <td style={{width: 10+'%', textAlign:'center'}}>{lineitem.quantity}</td>
                    <td style={{width: 20+'%', textAlign:'right'}}>${lineitem.price}</td>
                  </React.Fragment>
                  }
              </tr>
              )}
                      </tbody>
                  </table>
                  <div className="card-footer">
                    <h4 className="text-right">Line Item Total: ${invoice.lineitem_total}</h4>
                  </div>
                  <div className="card-footer">
                    <h2 className="text-right">Grand Total: ${invoice.due_amount}</h2>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={modalBackgroundClicked}>
              Back
            </button>
        </div>
      </React.Fragment>
    );
  }
}
export default InvoiceView;



// WEBPACK FOOTER //
// ./src/components/business/InvoiceView.js